import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent {

  constructor(private _route: Router) {
    this._route.events.subscribe((event) => {
      this.checkNavigation(event);
    });
  }

  checkNavigation(e) {
    const loadingContainer: HTMLElement = document.getElementsByClassName('loading').item(0) as HTMLElement;
    if (e instanceof NavigationStart) {
      loadingContainer.style.display = 'block';
    } else
      if (e instanceof NavigationCancel || e instanceof NavigationEnd || e instanceof NavigationError) {
        loadingContainer.style.display = 'none';
      }
  }
}
